<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    viewBox="0 0 12 12"
  >
    <g>
      <path
        :fill="color"
        d="M 4.655 9.263a.552.552 0 0 1 -.783 0L.744 6.135a.83.83 0 0 1 0 -1.175l.391 -.392a.83.83 0 0 1 1.176 0L 4.264 6.52 9.54 1.243a.83.83 0 0 1 1.175 0l.392.392a.83.83 0 0 1 0 1.175z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#2CEBA9',
    },
    size: {
      type: [Number, String],
      default: 12,
    },
  },
};
</script>
